module.exports = __webpack_public_path__ + "img/e888223.png";